import { ArrowRight, Briefcase, TrendingUp, Building2, Handshake } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/assets";

const CLIENT_TYPES = [
  { icon: Briefcase, label: "Client", copy: "seeking legal counsel or business advisory" },
  { icon: TrendingUp, label: "Investor", copy: "exploring Somalia's growth potential" },
  { icon: Building2, label: "Institution", copy: "requiring engineering or consulting support" },
  { icon: Handshake, label: "Partner", copy: "ready to collaborate on a shared mandate" },
];

export default function FinalCTA() {
  return (
    <section id="cta" data-testid="cta-section" className="relative bg-navy text-white overflow-hidden">
      {/* Watermark logo */}
      <div className="pointer-events-none absolute -left-24 top-1/2 -translate-y-1/2 opacity-[0.07]" aria-hidden="true">
        <img src={BRAND.logo} alt=""
             className="w-[700px] max-w-none brightness-0 invert" />
      </div>

      {/* Gold hairline top */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">Get In Touch</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.01em]">
            Whichever way you engage, Salihi Group is
            <em className="text-gold not-italic"> your integrated professional platform.</em>
          </h2>
          <p className="mt-6 text-white/75 text-base md:text-lg max-w-3xl font-light leading-relaxed">
            Whether you are a client seeking legal counsel, an investor exploring Somalia's growth potential, an institution
            requiring engineering support, or a partner ready to collaborate — we are set up to respond as one Group, through
            one professional relationship.
          </p>
        </div>

        {/* Client types grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
          {CLIENT_TYPES.map((t, i) => (
            <div key={t.label}
                 data-testid={`cta-client-type-${i}`}
                 className="border border-white/15 hover:border-gold p-6 group transition-colors">
              <t.icon size={24} strokeWidth={1.5} className="text-gold mb-4" />
              <div className="text-white text-lg font-serif">{t.label}</div>
              <div className="text-white/60 text-sm font-light mt-1">{t.copy}</div>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="mt-12">
          <Link to="/contact" className="btn-gold" data-testid="cta-contact-button">
            Contact Us <ArrowRight size={16} strokeWidth={2} />
          </Link>
        </div>
      </div>
    </section>
  );
}
